import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    ServiceDocumentSequenceUpdateInput
} from '@libs/types/src/services/input-type/services/settings/service-document-sequence.update-input';
import {
    ServiceDocumentSequenceGridObject
} from '@libs/types/src/services/object-type/service/settings/service-document-sequence.object';
import {
    ServiceDocumentSequenceCreateInput
} from '@libs/types/src/services/input-type/services/settings/service-document-sequence.create-input';

@Injectable({ providedIn: 'root' })
export class ServiceDocumentSequenceGqlService extends GqlServiceV2 {

    public getDocumentSequences(input: GridInput, fragment: string) {
        return this.query<ServiceDocumentSequenceGridObject>(
            `
                query($input: GridInput!) {
                    serviceDocumentSequence {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createDocumentSequence(
        input: ServiceDocumentSequenceCreateInput,
        fragment: string = 'ok',
    ) {
        return this.mutate<OkObject>(
            `
                mutation($input: ServiceDocumentSequenceCreateInput!) {
                    serviceDocumentSequence {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateDocumentSequence(
        input: ServiceDocumentSequenceUpdateInput,
        fragment: string = 'ok',
    ) {
        return this.mutate<OkObject>(
            `
                mutation($input: ServiceDocumentSequenceUpdateInput!) {
                    serviceDocumentSequence {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteDocumentSequence(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    serviceDocumentSequence {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
